"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fxhash_helpers_1 = require("@liamegan1/fxhash-helpers");
var p5_1 = __importDefault(require("p5"));
(0, fxhash_helpers_1.FXInit)(fxrand);
// Heck if I know, but this is solving my p5 import issues
var p5 = new p5_1.default(function (p5) { }, window.document.body);
var colors = {
    "🟠": {
        primary: "#443742ff",
        secondary: ["#003b36ff", "#ece5f0ff", "#dda448ff", "#d5573bff"],
    },
    "⚪️": {
        primary: "#d9dcd6ff",
        secondary: ["#b4869fff", "#985f6fff", "#172121ff", "#3a7ca5ff"],
    },
    "🔵": {
        primary: "#A6AFC5",
        secondary: [
            "#6D7194",
            "#9A2C22",
            "#00123F",
            "#DAD480",
            "#142818",
            "#FEFDF4",
        ],
    },
};
var partyLevel = {
    "🐌": 0.01,
    "🦆": 0.05,
    "💫": 0.1,
    "⚡️": 0.15,
    "🎉": 0.8,
};
var partyLikelihoods = [
    ["🐌", 10],
    ["🦆", 25],
    ["💫", 40],
    ["⚡️", 20],
    ["🎉", 5],
];
var thresh = function (iteration, seed, decay) {
    return (100000 * iteration * seed) % 99 < decay;
};
var seed = 0;
var bgColor;
var fgColors;
p5.setup = function () {
    seed = p5.int(fxrand() * 100000000);
    p5.randomSeed(seed);
    window.$fxhashFeatures = {
        "Color Setting": (0, fxhash_helpers_1.getWeightedOption)(partyLikelihoods),
        "Shape Setting": (0, fxhash_helpers_1.getWeightedOption)(partyLikelihoods),
        "Color Scheme": (0, fxhash_helpers_1.getWeightedOption)([
            ["🟠", 25],
            ["⚪️", 35],
            ["🔵", 40],
        ]),
    };
    var size = p5.min(p5.windowWidth, p5.windowHeight);
    p5.createCanvas(size, size);
    bgColor = colors[window.$fxhashFeatures["Color Scheme"]].primary;
    fgColors = colors[window.$fxhashFeatures["Color Scheme"]].secondary;
    p5.background(bgColor);
    p5.rectMode(p5.CENTER);
};
var arr = [[]];
var iteration = 1;
p5.draw = function () {
    p5.background(bgColor);
    var size = p5.min(p5.windowWidth, p5.windowHeight);
    var h = size;
    var w = size;
    // 10*3.5*x+9*x+2*1.25*x = 100
    var numButtons = 10;
    var buttonSize = 0.0752689; // 3.5
    var innerPad = 0.0215054; // 1
    var yOuterPad = 0.02688175; // 1.25
    var xOuterPad = 0.02688175;
    var colorDecay = partyLevel[window.$fxhashFeatures["Color Setting"]] * 2;
    var shapeDecay = partyLevel[window.$fxhashFeatures["Shape Setting"]] / 2;
    p5.noStroke();
    var _loop_1 = function (y) {
        var r = Math.floor(y / (innerPad * h + buttonSize * h));
        if (!arr[r]) {
            arr[r] = [];
        }
        var _loop_2 = function (x) {
            var c = Math.floor(x / (innerPad * h + buttonSize * h));
            if (!arr[r][c]) {
                var seed_1 = fxrand();
                arr[r][c] = {
                    seed: seed_1,
                    color: (0, fxhash_helpers_1.FXRandomOption)(fgColors, seed_1),
                    shape: (0, fxhash_helpers_1.FXRandomOption)(["square", "ellipse"], seed_1),
                };
            }
            // Chance to mutate
            if (thresh(iteration, arr[r][c].seed, colorDecay)) {
                arr[r][c].color =
                    fgColors[(fgColors.findIndex(function (cc) { return cc == arr[r][c].color; }) + 1) %
                        fgColors.length];
            }
            else if (thresh(iteration, arr[r][c].seed, shapeDecay)) {
                arr[r][c].shape = arr[r][c].shape === "square" ? "ellipse" : "square";
            }
            p5.fill(arr[r][c].color);
            if (arr[r][c].shape === "ellipse") {
                p5.ellipse(x, y, buttonSize * h, buttonSize * h);
            }
            else {
                p5.rect(x, y, buttonSize * h, buttonSize * h);
            }
        };
        for (var x = xOuterPad * w + (buttonSize * w) / 2; x <= w - xOuterPad; x += buttonSize * w + innerPad * w) {
            _loop_2(x);
        }
    };
    for (var y = yOuterPad * h + (buttonSize * h) / 2; y <= h - yOuterPad; y += buttonSize * h + innerPad * h) {
        _loop_1(y);
    }
    // todo: p5.deltaTime
    iteration += 1;
};
p5.keyPressed = function () {
    var S_KEY_CODE = 83;
    if (p5.keyCode === S_KEY_CODE) {
        p5.saveCanvas("".concat(fxhash), "png");
    }
};
p5.windowResized = function () {
    var size = p5.min(p5.windowWidth, p5.windowHeight);
    p5.resizeCanvas(size, size);
};
